import { Link, useLocation } from "react-router-dom";

interface HeroBusinessProps {
  title?: string;
  subtitle?: string;
}

const businessNav = [
  { path: "/business/integration", label: "연동방식" },
  { path: "/business/messaging", label: "메시징" },
  { path: "/business/aicc", label: "문자콜센터" },
  { path: "/business/alimtalk", label: "알림톡/브랜드톡" },
  { path: "/business/rcs", label: "RCS" },
];

const HeroBusiness = ({
  title = "비즈니스를 완성하는",
  subtitle = "혁신 솔루션",
}: HeroBusinessProps) => {
  const { pathname } = useLocation();

  return (
    <section className="flex items-end justify-between mx-auto">
      {/* 왼쪽 타이틀 */}
      <div className="text-black">
        <h1
          className="leading-[1.4]"
          style={{
            fontSize: "var(--font-display-large, 5.6rem)",
            fontWeight: 700,
          }}
        >
          {title}
          <br />
          {subtitle}
        </h1>
      </div>

      {/* 오른쪽 네비게이션 */}
      <nav aria-label="사업분야 메뉴">
        <ul className="flex m-0 list-none gap-[3.2rem] px-[3.4rem] py-[1.6rem] bg-white border border-[#e2e2e2] rounded-[1.2rem] shadow-[0_2px_8px_rgba(0,0,0,0.06)]">
          {businessNav.map((item, index) => {
            const isActive = pathname === item.path;

            return (
              <li key={item.path} className="relative whitespace-nowrap">
                {/* 구분선 */}
                {index < businessNav.length - 1 && (
                  <span
                    className="absolute -translate-y-1/2 top-1/2"
                    style={{
                      right: "-16px",
                      width: "1px",
                      height: "18px",
                      backgroundColor: "#c2c2c2",
                    }}
                  />
                )}

                <Link
                  to={item.path}
                  className="relative inline-block transition-colors"
                  style={{
                    fontSize: "var(--font-title-medium, 1.8rem)",
                    color: isActive ? "#333" : "#717171",
                    fontWeight: 500,
                    textDecoration: "none",
                  }}
                >
                  {item.label}

                  {/* Active underline */}
                  <span
                    className="absolute left-0 bottom-[-2px] h-[2px] bg-black transition-all duration-300"
                    style={{
                      width: isActive ? "100%" : "0%",
                    }}
                  />
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </section>
  );
};

export default HeroBusiness;
